/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef} from "react";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { getTodoList, getMasterData, getWatchlistNumber, bulkUpdateTaskMilestone } from "../../services/chartService";
import "react-calendar/dist/Calendar.css";
import "./coder.css";
import Select from "react-select";
import CustomPagination from "../Manager/ManagerWorkLists/CustomPagination";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import {  getProjectMembers } from "../../services/managerWorkListService";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { imageIdGenerate } from "../../utils/custom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import CoderHome from "./CoderHome";

const TODO_FILTER_STORAGE_KEY = "todoListFilters";

const getSavedTodoFilters = () => {
  try {
    const raw = sessionStorage.getItem(TODO_FILTER_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const ToDoList = ({ showtable = localStorage.getItem('attending') === "true" ? true : false, onQuery, setFilterForToDoList, attendanceProp, show, query }) => {
  const routeLocation = useLocation();
  const navigate = useNavigate();
  const savedTodoFilters = getSavedTodoFilters();
  // const [taskProcess, setTaskProcess] = useState([]);
  const [taskType, setTaskType] = useState([]);
  const [milestone, setMilestone] = useState([]);
  const [taskNameOptions, setTaskNameOptions] = useState([]);
  const [priority, setpriority] = useState(savedTodoFilters?.priority ?? "Critical");
  const critical = "Critical";
  const medium = "Medium";
  const low = "Low";
  const high = "High";
  const [chartData, setChartData] = useState([]);
  const [inpval, setInputval] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [key, setKey] = useState(0);
  const [total, setTotal] = useState({});
  const [dateOfService, setDateOfService] = useState(savedTodoFilters?.dateOfService ?? "");
  const [receivedDate, setReceivedDate] = useState(savedTodoFilters?.receivedDate ?? "");
  const [loader, setLoader] = useState(false);
  const [noData, setNoData] = useState(false);
  const [coderFilter, setCoderFilter] = useState([]);
  const [defaultSpeciality, setDefaultSpeciality] = useState([]);
  const [defaultMilestone, setDefaultMilestone] = useState(savedTodoFilters?.defaultMilestone ?? []);
  // const [defaultProcess, setDefaultProcess] = useState([]);
  const [defaultTaskType, setDefaultTaskType] = useState(savedTodoFilters?.defaultTaskType ?? []);
  const [defaultChartStatus, setDefaultChartStatus] = useState([]);
  const [serialNumberFrom, setSerialNumberFrom] = useState("");
  const [serialNumberTo, setSerialNumberTo] = useState("");
  const [filObj, setFilObj] = useState(savedTodoFilters?.filObj ?? {});
  const [filterPagination, setFilterPagination] = useState(false);
  const [selectedOptionWorkList, setSelectedOptionWorkList] = useState(savedTodoFilters?.selectedOptionWorkList ?? [routeLocation?.state?.worklist_number ?? ""]);
  // const [selectedOptionChart, setSelectedOptionsChart] = useState([]);
  const [globalChartSearch, setGlobalChartSearch] = useState({})
  const [resetForm, setResetForm] = useState(false)
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const isLoading = false;
  const ignoreDiacritics = true;
  const typeAheadRefTaskName = useRef(null);
  const typeheadRefTaskNumber = useRef(null);
  const typeAheadRefProject= useRef(null);
  const [taskName, setTaskName] = useState(savedTodoFilters?.taskName ?? "");
  const [optionsChart, setOptionsChart] = useState([]);
  const [taskNumber,setTaskNumber] = useState(savedTodoFilters?.taskNumber ?? [routeLocation?.state?.submitData?.chart_no ?? ""]);
  const [optionsWorklist,setOptionsWorklist] = useState([]);
  const [projectMembers, setProjectMembers] = useState([]);
  const [defaultAssignee, setDefaultAssignee] = useState(savedTodoFilters?.defaultAssignee ?? {});
  const [milestones, setMilestones] = useState({});
  const [selectedTaskIds, setSelectedTaskIds] = useState([]);
  const [bulkMilestone, setBulkMilestone] = useState(null);
  const [bulkUpdating, setBulkUpdating] = useState(false);

  let filterObj = {};
  const filterSubmit = async (type, globalTriggering = false) => {

    setInputval(() => {
      return {
        ...inpval,
      };
    });

    setLoader(true);
    if (type !== "reset") {
    const hasDateValue = (val) => val && !Array.isArray(val) && String(val).trim() !== "";
    const startRaw = hasDateValue(dateOfService) ? String(dateOfService).trim() : "";
    const endRaw = hasDateValue(receivedDate) ? String(receivedDate).trim() : "";
    const startPart = startRaw ? startRaw.split(" - ")[0].trim() : "";
    const endPart = endRaw ? endRaw.split(" - ").pop().trim() : "";
    let startDateFilter = "";
    let endDateFilter = "";
    if (startPart && endPart) {
      startDateFilter = `${startPart} - ${endPart}`;
    } else if (startPart) {
      startDateFilter = startRaw.includes(" - ") ? startRaw : `${startPart} - ${startPart}`;
    } else if (endPart) {
      endDateFilter = endRaw.includes(" - ") ? endRaw : `${endPart} - ${endPart}`;
    }
    filterObj = {
      // ...inpval,
      start_date: startDateFilter,
      end_date: endDateFilter,
      // processid: defaultProcess?.length !== 0 ? defaultProcess?.map((item) => item.value) : "",
      task_type: defaultTaskType?.length !== 0 ? defaultTaskType?.map((item) => item.value) : "",
      specialty: defaultSpeciality?.length !== 0 ? defaultSpeciality?.map((item) => item.value) : "",
      milestone: defaultMilestone?.length !== 0 ? defaultMilestone?.map((item) => item.value) : "",
      latest_coder: coderFilter?.length !== 0 ? coderFilter?.map((item) => item.value) : "",
      chart_status: defaultChartStatus?.length !== 0 ? defaultChartStatus?.map((item) => item.value) : "",
      s_no_from: (serialNumberFrom === "" || serialNumberFrom === undefined) ? routeLocation?.state?.s_no_from : serialNumberFrom,
      s_no_to: (serialNumberTo === "" || serialNumberTo === undefined) ? routeLocation?.state?.s_no_to : serialNumberTo,
      worklist_number: (selectedOptionWorkList?.length === 0) ? routeLocation?.state?.worklist_number : selectedOptionWorkList,
      task_name: taskName,
      chart_no: taskNumber !== "" && taskNumber !== undefined ? (taskNumber.length !==0 ? taskNumber.toString() : "") : "",
      assignee: defaultAssignee.value ?? ""
    };
    if(globalTriggering) {
    if(globalChartSearch.hasOwnProperty('dateOfService') && filterObj.date_of_service === '' && !resetForm) { filterObj.date_of_service = globalChartSearch.dateOfService }
    if(globalChartSearch.hasOwnProperty('receivedDate') && filterObj.received_date === '' && !resetForm) { filterObj.received_date = globalChartSearch.receivedDate }
    // if(globalChartSearch.hasOwnProperty('dateOfCompletion') && filterObj.completion_date === '' && !resetForm) { filterObj.completion_date = globalChartSearch.dateOfCompletion }
    if(globalChartSearch.hasOwnProperty('taskNumber') && filterObj.chart_no === '' && !resetForm) { filterObj.chart_no = globalChartSearch.chart_no }
    }
    try {
      sessionStorage.setItem(TODO_FILTER_STORAGE_KEY, JSON.stringify({
        defaultMilestone,
        defaultTaskType,
        defaultAssignee,
        dateOfService,
        receivedDate,
        taskName,
        taskNumber,
        selectedOptionWorkList,
        filObj: filterObj,
        priority,
      }));
    } catch {
      // Ignore storage write failures (private mode, quota, etc.)
    }
    }else{
      navigate("/", { state: { } });
    }
    setFilObj(filterObj);
    setFilterPagination(true);
    setFilterForToDoList(filterObj);
  };

  const chartListFilterButton = document.querySelector('#chart_list_filter_button')

  const setMenuStaticProperty = (isStatic) => {
    if (!isStatic) {
      setTimeout(
        () => { chartListFilterButton?.setAttribute('data-kt-menu-static', isStatic) }
        , 500)
    } else {
      chartListFilterButton?.setAttribute('data-kt-menu-static', isStatic)
    }
  }

  useEffect(() => {
    if (showtable === true) {
      fetchTodoList(priority, pageSize, currentPage);
    }
    fetchMasterData();
  }, [pageSize, priority, currentPage, filterPagination, filObj, showtable]);

  useEffect(() => {
    try {
      const existing = getSavedTodoFilters() ?? {};
      sessionStorage.setItem(TODO_FILTER_STORAGE_KEY, JSON.stringify({ ...existing, priority }));
    } catch {
      // Ignore storage write failures (private mode, quota, etc.)
    }
  }, [priority]);

  const handleSearchWorkList = async (query) => {
    let postData = {
      worklist: query,
    };

    const items = await getWatchlistNumber(postData);
    const workList = items?.data?.typeaheadWorkListRecord;
    setOptionsWorklist(workList);
  };

  const handleSearchChart = async (query) => {
    let postData = {
      chart_no: query,
    };
    const items = await getWatchlistNumber(postData);
    const chart = items?.data?.typeaheadChartRecord;
    setOptionsChart(chart);
  };

  const handleSearchTaskName = async (query) => {
    let postData = {
      task_name: query,
    };
    const items = await getWatchlistNumber(postData);
    const taskName = items?.data?.typeAheadTaskName;
    setTaskNameOptions(taskName);
  };

  const fetchTodoList = async (priority, pageSize, currentPage) => {
    let response;
    if (filterPagination === true) {
      setCurrentPage(1);
      setFilterPagination(false);
    }
    setLoader(true);
    if ((serialNumberFrom === "" || serialNumberFrom === undefined) && (serialNumberTo === "" || serialNumberTo === undefined) && (selectedOptionWorkList.length === 0)) {
      filObj.worklist_number = [routeLocation?.state?.worklist_number];
      filObj.worklist_id = routeLocation?.state?.worklist_id;
      filObj.s_no_from = routeLocation?.state?.s_no_from;
      filObj.s_no_to = routeLocation?.state?.s_no_to;
      filObj[routeLocation?.state?.role] = [routeLocation?.state?.id];
      response = await getTodoList(priority, pageSize, currentPage, filObj);
    } else {
      response = await getTodoList(priority, pageSize, currentPage, filObj);
    }
    if (response?.charts.length === 0) {
      setNoData(true);
    } else {
      setNoData(false);
    }
    setLoader(false);
    setChartData(response?.charts);
    setTotal(response?.counts);
    setMilestones(response?.milestoneData?.milestones);
    setSelectedTaskIds([]);
    setBulkMilestone(null);
    window.KTMenu.init();
  };

  useEffect(() => { }, [chartData]);

  const handleLinkClick = (taskNo) => {
    localStorage.setItem("key", taskNo);
    navigate(`/task/${taskNo}`);
  };

  const visibleTaskIds = (chartData ?? []).map((row) => row?.Id).filter((id) => id !== undefined && id !== null);
  const isAllVisibleSelected = visibleTaskIds.length > 0 && visibleTaskIds.every((id) => selectedTaskIds.includes(id));

  const toggleRowSelection = (event, taskId) => {
    event.stopPropagation();
    setSelectedTaskIds((prev) => (prev.includes(taskId) ? prev.filter((id) => id !== taskId) : [...prev, taskId]));
  };

  const toggleSelectAllVisible = (event) => {
    event.stopPropagation();
    setSelectedTaskIds(isAllVisibleSelected ? [] : visibleTaskIds);
  };

  const clearSelection = () => {
    setSelectedTaskIds([]);
    setBulkMilestone(null);
  };

  const handleBulkMilestoneUpdate = async () => {
    if (!bulkMilestone?.value || selectedTaskIds.length === 0) {
      return;
    }
    setBulkUpdating(true);
    const response = await bulkUpdateTaskMilestone({ task_ids: selectedTaskIds, milestone_id: bulkMilestone.value });
    setBulkUpdating(false);
    if (response?.success) {
      window.toastr.success(response?.message ?? "Task milestone updated successfully");
      fetchTodoList(priority, pageSize, currentPage);
    } else {
      window.toastr.error(response?.message ?? "Cannot update task milestones");
    }
  };

  const triggerFilterOpen = () => {
    setTimeout(() => {
      document.querySelector("button.btn-filter").dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        })
      );
    }, 10);
  };

  const renderProjectMembersList = () => {
    return projectMembers?.map((member) => ({
      label: `${member.first_name} ${member.last_name}`,
      value: member.id,
      image: member.image_url ?? `${process.env.PUBLIC_URL}/assets/media/avatars/300-${imageIdGenerate(member?.id)}.jpg`
    }));
  };

  const handleTaskAssigneeChange = (event) => {
    setDefaultAssignee({
      label: `${event.label}`,
      value: event.value,
      image: event.image
    });
    triggerFilterOpen();
  };

  const switchMilestoneBadgeClasses = (milestone)=>{
    switch (milestone) {
      case 'Todo':
        return 'badge-light-info'
      case 'In Progress':
        return 'badge-light-primary'
      case 'Ready for QA':
        return 'badge-light-danger'
      case 'QA in Progress':
        return 'badge-light-dark'
      case 'Ready for Client Review':
        return 'bs-yellow-light text-yellow '
      case 'Approved':
        return 'badge-light-success'
      default:
        return 'badge-light'
    }
  }

  const showTable = (value) => {
    return chartData?.map((row) => (
      <tr key={row?.TaskNo} onClick={() => handleLinkClick(row?.TaskNo)} style={{ cursor: "pointer" }}>
        <td onClick={(e) => e.stopPropagation()}>
          <div className="form-check form-check-sm form-check-custom form-check-solid">
            <input
              className="form-check-input"
              type="checkbox"
              checked={selectedTaskIds.includes(row?.Id)}
              onChange={(e) => toggleRowSelection(e, row?.Id)}
            />
          </div>
        </td>
        <td><Link to={`/task/${row?.TaskNo}`} onClick={(e) => e.stopPropagation()}><strong className="text-gray-900">{row?.Worklist}</strong></Link></td>
        <td>{row?.epic_name}</td>
        <td><Link to={`/task/${row?.TaskNo}`} onClick={(e) => e.stopPropagation()}>{row?.TaskNo}</Link></td>
        <td><Link to={`/task/${row?.TaskNo}`} onClick={(e) => e.stopPropagation()}>{row?.TaskName}</Link></td>
        <td>
          <div className="px-6 symbol-hover flex-nowrap">
            <OverlayTrigger overlay={<Tooltip>{(row?.AssigneeFirstName || row?.AssigneeLastName) ? `${row?.AssigneeFirstName ?? ""} ${row?.AssigneeLastName ?? ""}` : 'Unassigned' }</Tooltip>} key={row?.assignee_id} placement={"right"}>
              <div className="symbol symbol-35px symbol-circle user-image" data-kt-initialized="1">
                <img alt="assignee" src={row?.assignee_id ? ( row?.assignee_image_url ?? `${process.env.PUBLIC_URL}/assets/media/avatars/300-${imageIdGenerate(row?.assignee_id)}.jpg`): (`${process.env.PUBLIC_URL}/assets/media/avatars/blank.png`)} />
              </div>
            </OverlayTrigger>
          </div>
        </td>
        <td>{row?.StartDate}</td>
        <td>{row?.EndDate}</td>
        <td>
          <div className={`badge fw-bold ${switchMilestoneBadgeClasses(row?.Milestone)}` }>{row?.Milestone}</div>
        </td>
        <td>{row?.task_type}</td>
      </tr>
    ));
  };

  const handleMilestoneChange = (event) => {
    setDefaultMilestone(event);
    triggerFilterOpen();
  };

  const handleTaskTypeChange = (event) => {
    setDefaultTaskType(event);
    triggerFilterOpen();
  };

  const fetchMasterData = () => {
    getMasterData()
      .then((response) => {
        // setTaskProcess(response.data?.processes);
        setTaskType(response.data?.task_type);
        setMilestone(response.data?.milestones);
       let userId =  localStorage.getItem("loginUserId");
       let userFound = response?.data?.users_all.find(user => user.id === (filObj?.assignee === "" ? Number(userId) : filObj?.assignee));
        setDefaultAssignee({
          label: userFound?.name,
          value: userFound?.id,
          image: userFound?.image
        });
      })
      .catch((error) => {
        console.log(error);
      });
      getProjectMembers('all ').then(response => {
        setProjectMembers(response?.data);
      });
  };
  const setcritical = () => {
    setCurrentPage(1);
    setpriority(critical);
  };

  const sethigh = () => {
    setCurrentPage(1);
    setpriority(high);
  };

  const setmedium = () => {
    setCurrentPage(1);
    setpriority(medium);
  };

  const setlow = () => {
    setCurrentPage(1);
    setpriority(low);
  };

  const handleResetFields = () => {
    document.getElementById("dateRangePickerDateOfService").value = "";
    document.getElementById("dateRangePickerReceiveDate").value = "";
    setSerialNumberFrom("");
    setSerialNumberTo("");
    setDefaultMilestone([]);
    // setDefaultProcess([]);
    setDefaultTaskType([]);
    setDefaultSpeciality([]);
    setCoderFilter([]);
    setDateOfService("");
    setReceivedDate("");
    setDefaultChartStatus([]);
    typeAheadRefTaskName.current.clear();
    typeheadRefTaskNumber.current.clear();
    typeAheadRefProject.current.clear();
    setTaskName("");
    setTaskNumber("");
    setSelectedOptionWorkList("");
    setInputval({});
    setFilObj({});
    setDefaultAssignee({});
    sessionStorage.removeItem(TODO_FILTER_STORAGE_KEY);
    triggerFilterOpen();
    navigate(routeLocation.pathname, { state: null });
    setResetForm(true)
  };

  const renderMilestone = () => {
    return milestone?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  // const renderProcess = () => {
  //   return taskProcess?.map((data) => ({
  //     label: data?.name,
  //     value: data?.id,
  //   }));
  // };

  const renderTaskType = () => {
    return taskType?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };
  

  useEffect(() => {
    if(!resetForm) {
      if (routeLocation?.state?.submitData) {
        setGlobalChartSearch({
          dateOfService: routeLocation?.state?.submitData?.date_of_service ?? "",
          receivedDate: routeLocation?.state?.submitData?.receivedDate ?? "",
          dateOfJoining: routeLocation?.state?.submitData?.completion_date ?? "",
          chart_no: routeLocation?.state?.submitData?.chart_no ?? ""
        });
        setDateOfService(routeLocation?.state?.submitData?.date_of_service ?? "");
        setReceivedDate(routeLocation?.state?.submitData?.receivedDate ?? "");
        // setDateOfCompletion(routeLocation?.state?.submitData?.completion_date ?? "");
        setTaskNumber(routeLocation?.state?.submitData?.chart_no ?? "");
      }
    } else {
      setResetForm(false)
    }
  }, [routeLocation])

  useEffect(() => {
    filterSubmit("submit", true)
  }, [globalChartSearch])

  const handleEventDateOfService = (event, picker) => {
    picker.element.val(picker.startDate.format("DD/MM/YYYY") + " - " + picker.endDate.format("DD/MM/YYYY"));
    setDateOfService(picker.startDate.format("DD/MM/YYYY") + " - " + picker.endDate.format("DD/MM/YYYY"));
  };

  const handleEventReceiveDate = (event, picker) => {
    picker.element.val(picker.startDate.format("DD/MM/YYYY") + " - " + picker.endDate.format("DD/MM/YYYY"));
    setReceivedDate(picker.startDate.format("DD/MM/YYYY") + " - " + picker.endDate.format("DD/MM/YYYY"));

  }
  
  const handleCancelDateOfService = (event, picker) => {
    picker.element.val('');
    setDateOfService('');
  }
  const handleCancelReceiveDate = (event, picker) => {
    picker.element.val('');
    setReceivedDate('');

  }
  
  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [taskNumber]);

  const handleInputNumberChange = (input) => {
    if (input === '') {
      setTaskNumber('');
    }
  };
  const handleInputNameChange = (input) => {
    if (input === '') {
      setTaskName('');
    }
  };
  const handleInputChange = (input) => {
    if (input === '') {
      setSelectedOptionWorkList('');
    }
  }

  return (
    <>
      <CoderHome milestones={milestones} />
      <div>
        <div className="d-flex justify-content-between progress-button">
          <h3 className="pb-0 mb-4 ms-3 pt-5">My To-do List</h3>
        </div>

        <div className="card priority-card">
          <div className="card-header pt-7 border-bottom-0">
            <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6" role="tablist">
              <li className="nav-item" role="presentation">
                <Link className={`nav-link ${priority === critical ? "active" : ""}`} onClick={() => { setcritical(); }} data-bs-toggle="tab" href="#kt_tab_pane_critical" aria-selected={priority === critical} role="tab" > Critical ({total?.Critical}) </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link className={`nav-link ${priority === high ? "active" : ""}`} data-bs-toggle="tab" onClick={() => { sethigh(); }} href="#kt_tab_pane_medium" aria-selected={priority === high} role="tab" tabIndex={-1} > High ({total?.High}) </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link className={`nav-link ${priority === medium ? "active" : ""}`} data-bs-toggle="tab" onClick={() => { setmedium(); }} href="#kt_tab_pane_medium" aria-selected={priority === medium} role="tab" tabIndex={-1} > Medium ({total?.Medium}) </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link className={`nav-link ${priority === low ? "active" : ""}`} data-bs-toggle="tab" onClick={() => { setlow(); }} href="#kt_tab_pane_low" aria-selected={priority === low} role="tab" tabIndex={-1} > Low ({total?.Low}) </Link>
              </li>
            </ul>
            <div className="d-flex">
              <div>
                <button type="button" id="chart_list_filter_button" className="btn btn-light-primary ms-4 btn-filter" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                  <i className="fas fa-filter"></i>
                  {" Filter"}
                </button>

                <div className="menu menu-sub menu-sub-dropdown w-900px w-md-900px" data-kt-menu="true">
                  <div className="px-7 py-5">
                    <div className="fs-5 text-dark fw-bold">Filter Options</div>
                  </div>

                  <div className="separator border-gray-200" />

                  <div className="px-7 py-5 scroll-y chart-filter" data-kt-user-table-filter="form">
                    <div className="row mb-3">
                      <div className="col-lg-4 col-6  mb-4">
                        <div className="mb-4">
                          <label className="form-label">Task Number</label>
                          <AsyncTypeahead
                            filterBy={() => true}
                            placeholder="..."
                            key={key}
                            isLoading={isLoading}
                            id="chart_no"
                            ignoreDiacritics={ignoreDiacritics}
                            labelKey="unique_task_no"
                            options={optionsChart}
                            value={taskNumber}
                            defaultInputValue={Array.isArray(taskNumber) ? taskNumber.join(', ') : ''}
                            minLength={2}
                            onSearch={handleSearchChart}
                            onInputChange={handleInputNumberChange}
                            renderMenuItemChildren={(option) => (
                              <>
                                <span>{option.unique_task_no}</span>
                              </>
                            )}
                            ref={typeheadRefTaskNumber}
                            onChange={(selected) => {
                              setTaskNumber([selected[0]?.unique_task_no]);
                              triggerFilterOpen();
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-6  mb-4">
                        <div className="mb-4">
                          <label className="form-label">Task Name</label>
                          <AsyncTypeahead
                            filterBy={() => true}
                            placeholder="..."
                            isLoading={isLoading}
                            id="task_name"
                            ignoreDiacritics={ignoreDiacritics}
                            labelKey="name"
                            options={taskNameOptions}
                            value={taskName}
                            defaultInputValue={Array.isArray(taskName) ? taskName.join(', ') : (taskName || '')}
                            minLength={2}
                            debounceTime
                            useCache={false}
                            onSearch={handleSearchTaskName}
                            onInputChange={handleInputNameChange}
                            renderMenuItemChildren={(option) => (
                              <>
                                <span>{option.name}</span>
                              </>
                            )}
                            ref={typeAheadRefTaskName}
                            onChange={(selected) => {
                              setTaskName([selected[0]?.name]);
                              triggerFilterOpen();
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-6  mb-4">
                        <div className="mb-4">
                          <label className="form-label">Project</label>
                          <AsyncTypeahead
                            filterBy={() => true}
                            isLoading={isLoading}
                            id="worklistdata"
                            placeholder="..."
                            ignoreDiacritics={ignoreDiacritics}
                            labelKey="worklist_no"
                            options={optionsWorklist}
                            value={selectedOptionWorkList}
                            defaultInputValue={Array.isArray(selectedOptionWorkList) ? selectedOptionWorkList.join(', ') : ''}
                            minLength={1}
                            onSearch={handleSearchWorkList}
                            onInputChange={handleInputChange}
                            renderMenuItemChildren={(option) => (
                              <>
                                <span>{option?.name} ( {option.worklist_no} )</span>
                              </>
                            )}
                            ref={typeAheadRefProject}
                            onChange={(selected) => {
                              setSelectedOptionWorkList([selected[0]?.worklist_no]);
                              triggerFilterOpen();
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-xl-4 col-lg-4 col-12 mb-4">
                        <label className="form-label">Assignee</label>
                        <Select
                          id="assignee"
                          name="assignee_id"
                          options={renderProjectMembersList()}
                          isMulti={false}
                          value={defaultAssignee}
                          isDisabled={false}
                          onChange={handleTaskAssigneeChange}
                          formatOptionLabel={(user) => {
                            if (!user.value) {
                              return <span className="fw-semibold">...</span>;
                            } else {
                              return (
                                <div value={user?.value ?? ""}>
                                  <img width="30" height="30" style={{ borderRadius: "50%", marginRight: "10px" }} src={user?.value !== "unassigned" ? user?.image ?? `${process.env.PUBLIC_URL}/assets/media/avatars/300-${imageIdGenerate(user?.value)}.jpg` : `${process.env.PUBLIC_URL}/assets/media/avatars/blank.png`} alt="user.img" />
                                  <span className="fw-semibold">{user?.value !== "unassigned" ? user?.label ?? "" : "Unassigned"}</span>
                                </div>
                              );
                            }
                          }}
                        />
                      </div>
                      <div className="col-lg-4 col-12 mb-4">
                        <label className="form-label mb-2">
                          <span>Start Date</span>
                        </label>
                        <DateRangePicker
                          initialSettings={{ autoUpdateInput: false, locale: { cancelLabel: "Clear", format: "DD/MM/YYYY" }, showDropdowns: true }}
                          onShow={() => { setMenuStaticProperty(true) }}
                          onHide={() => { setMenuStaticProperty(false) }}
                          onApply={handleEventDateOfService}
                          style={{ zIndex: "20" }}
                          onCancel={handleCancelDateOfService}
                        >
                          <input type="text" id="dateRangePickerDateOfService" defaultValue={dateOfService} placeholder="Select Date" autoComplete="off" className="form-control" />
                        </DateRangePicker>
                      </div>
                      <div className="col-lg-4 col-12 mb-4">
                        <label className="form-label mb-2">
                          <span>End Date</span>
                        </label>
                        <DateRangePicker
                          initialSettings={{ autoUpdateInput: false, locale: { cancelLabel: "Clear", format: "DD/MM/YYYY" }, showDropdowns: true }}
                          onShow={() => { setMenuStaticProperty(true) }}
                          onHide={() => { setMenuStaticProperty(false) }}
                          onApply={handleEventReceiveDate}
                          style={{ zIndex: "20" }}
                          onCancel={handleCancelReceiveDate}
                        >
                          <input type="text" id="dateRangePickerReceiveDate" defaultValue={receivedDate} className="form-control" placeholder="Select Date" autoComplete="off" />
                        </DateRangePicker>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-lg-4 col-12 mb-4">
                        <label className="form-label">Milestone </label>
                        <Select options={renderMilestone()} isMulti={true} value={defaultMilestone} onChange={handleMilestoneChange} />
                      </div>
                      <div className="col-lg-4 col-12 mb-4">
                        <label className="form-label">Type </label>
                        <Select id="task_type" options={renderTaskType()} isMulti={true} value={defaultTaskType} onChange={handleTaskTypeChange} />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button type="reset" className="btn btn-sm btn-light btn-active-light-primary me-2" data-kt-menu-dismiss="true" onClick={() => { filterSubmit("reset"); handleResetFields(); }} >
                        Reset
                      </button>
                      <button type="submit" onClick={() => filterSubmit("apply")} className="btn btn-sm btn-primary" data-kt-menu-dismiss="true">
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body  py-2">
            <div>
              {selectedTaskIds.length > 0 && (
                <div className="d-flex align-items-center bg-light-primary rounded p-4 mb-5">
                  <span className="fw-bold text-gray-800 me-4">{selectedTaskIds.length} task(s) selected</span>
                  <div style={{ minWidth: "220px" }} className="me-3">
                    <Select
                      options={renderMilestone()}
                      isMulti={false}
                      placeholder="Move to milestone..."
                      value={bulkMilestone}
                      onChange={setBulkMilestone}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary me-2"
                    disabled={!bulkMilestone?.value || bulkUpdating}
                    onClick={handleBulkMilestoneUpdate}
                  >
                    {bulkUpdating ? "Updating..." : "Update"}
                  </button>
                  <button type="button" className="btn btn-sm btn-light" onClick={clearSelection} disabled={bulkUpdating}>
                    Clear
                  </button>
                </div>
              )}
              <div className="separator separator-dashed my-5 mt-0" />
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="kt_tab_pane_critical" role="tabpanel">
                  <div className="table-responsive">
                    <table className="table align-middle table-row-dashed fs-6 gy-5" id="kt_table_todo_list">
                      <thead>
                        <tr className="text-start text-dark fw-bold fs-7 text-uppercase gs-0">
                          <th className="w-25px">
                            <div className="form-check form-check-sm form-check-custom form-check-solid">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isAllVisibleSelected}
                                onChange={toggleSelectAllVisible}
                                disabled={visibleTaskIds.length === 0}
                              />
                            </div>
                          </th>
                          <th className="min-w-80px">Project</th>
                          <th className="min-w-80px">Epic</th>
                          <th className="min-w-80px">Task #</th>
                          <th className="min-w-80px">Task Name</th>
                          <th className="min-w-80px">Assignee</th>
                          <th className="min-w-80px">Start Date</th>
                          <th className="min-w-80px">End Date</th>
                          <th className="min-w-80px">Milestone</th>
                          <th className="min-w-80px">Type</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-600 fw-semibold">{chartData && showTable(priority)}</tbody>
                    </table>{" "}
                    {loader === false && noData === true && <div>No Records Found ...</div>}
                    {noData === false && <CustomPagination dataPerPage={pageSize} totalData={total?.[priority]} paginate={paginate} currentPage={currentPage} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ToDoList;
